<template>
  <master-layout>
    <ion-grid>
      <ion-row>
        <ion-col size="6">
          <div class="center-red">Salam</div>
        </ion-col>
        <ion-col size="6">
          {{ fullName }}
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="6">
          <input class="form-control" v-model="fullName"/>
        </ion-col>
        <ion-col size="6">
          {{ msg }}
        </ion-col>
        <ion-col size="6">
          <button @click="doTheThing" class="btn btn-success">Do The Thing</button>
        </ion-col>
      </ion-row>
    </ion-grid>
    <br/>
    <br/>
    <input class="form-control" v-model="search" placeholder="برای جستجو چیزی تایپ کنید" />
    <br/>
    <br/>
    <table class="table">
      <thead>
      <tr>
        <th>شناسه</th>
        <th>نام</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="student in filteredStudents" :key="student.id">
        <td>{{student.id}}</td>
        <td>{{student.name}}</td>
      </tr>
      </tbody>
    </table>

    <table class="table">
      <thead>
      <tr>
        <th>عنوان</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="state in states" :key="state._id">
        <td>{{state.title}}</td>
      </tr>
      </tbody>
    </table>
  </master-layout>
</template>

<script>
import {IonGrid, IonRow, IonCol} from '@ionic/vue';
import {mapActions} from "vuex";

export default {
  name: "ali",
  mounted()
  {
    this.listStates().then((states)=>{
      this.states = states;
    })
  },
  data()
  {
    return {
      fullName: '',
      states:[],
      students: [
        {id: 61, name: 'Hamid'},
        {id: 6121, name: 'Ali'},
        {id: 321, name: 'Amin'},
      ],
      search:'',
      msg: ''
    }
  },
  watch: {
    fullName()
    {
      this.msg = this.fullName + ' عزیز، خوش آمدید'
    }
  },
  methods: {
    doTheThing()
    {
      alert(this.msg)
    },
    ...mapActions('app',{
      listStates:"getStates"
    })
  },
  computed:{
    filteredStudents()
    {
      if (this.search.length)
      {
        let items = [];
        for (let i=0;i<this.students.length;i++)
        {
          if (this.students[i].name.toLowerCase().indexOf(this.search.toLowerCase())>=0 || this.students[i].id.toString().indexOf(this.search)>=0)
            items.push(this.students[i]);
        }
        return items;
      }
      return this.students;
    }
  },
  components: {IonGrid, IonRow, IonCol},
}
</script>

<style scoped>
.center-red {
  text-align: center;
  color: red;
}
</style>